import {
  WheelPrize,
  WheelSegment,
} from '@longnecktech/splash-commons-fe/dist/types/wheel/wheel';
import { MultiWheelQuestion } from '@longnecktech/splash-commons-fe/dist/types/multi-wheel/multi-wheel-question';

export interface MultiWheelSpin {
  uuid: string;
  createdTs: Date;
  question: MultiWheelQuestion;
  outerSegment: WheelSegment;
  innerSegment: WheelSegment;
  outcome: MultiWheelOutcome;
  prize: WheelPrize;
  shown: boolean;
}

export enum MultiWheelOutcome {
  WON = 'WON',
  LOST = 'LOST',
  PENDING = 'PENDING',
}
